module.exports = __webpack_public_path__ + "img/comment-smile.96b1b29e.svg";